import type { TemplateCategoryDto } from "@/modules/template/gateway/templateCategoryDto"

export class TemplateCategoryEntity {
  id: string
  name: string

  private constructor(templateCategory: TemplateCategoryEntity) {
    this.id = templateCategory.id
    this.name = templateCategory.name
  }

  static fromDto(dto: TemplateCategoryDto): TemplateCategoryEntity {
    return new TemplateCategoryEntity({
      id: dto.id,
      name: dto.name,
    })
  }
}
